<template>
  <div class="catalog_module">
    <div class="search flex">
      <span class="tit">反馈管理</span>
      <div class="flex">
        <el-checkbox-button v-model="isScreenSelected"
                            size="mini"
                            @change="getData()">
          筛选精选
        </el-checkbox-button>
        <el-button @click="updateSort()" size="mini" class="addBtn">重新排序</el-button>
<!--        <el-input-->
<!--            suffix-icon="el-icon-search"-->
<!--            class="addART"-->
<!--            v-model="search"-->
<!--            size="mini"-->
<!--            placeholder="输入关键字搜索"/>-->
      </div>
    </div>
    <div class="instrument">
      <el-table
          :data="feedbackList"
          class="record-table"
          :header-cell-style="{'background':'rgba(86,123,255,0.1)','color': '#666','fontWeight':'400','textAlign':'center'}"
          height="calc(100vh - 292px)"
          style="width: 100%;font-size:14px;color:#333;font-weight:400;margin-bottom: 10px;"
          row-key="id"
          @sort-change="sortChange"
          max-height="calc(100vh - 292px)">
        <el-table-column
            align="center"
            prop="userId"
            label="反馈人"
            width="120"
            show-overflow-tooltip>
        </el-table-column>
        <el-table-column
            align="center"
            prop="title"
            label="标题"
            width="160"
            show-overflow-tooltip>
        </el-table-column>
        <el-table-column
            align="center"
            prop="content"
            label="内容"
            show-overflow-tooltip>
        </el-table-column>
        <el-table-column
            align="center"
            prop="contact"
            label="联系方式"
            width="200" show-overflow-tooltip>
        </el-table-column>
        <el-table-column
            align="center"
            prop="submitDate"
            label="提交日期"
            sortable="custom"
            width="160" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.row.submitDate.replace("T", " ") }}
          </template>
        </el-table-column>
        <el-table-column
            align="center"
            prop="status"
            label="状态"
            sortable="custom"
            width="80">
          <template slot-scope="scope">
            <el-button size="mini" type="text" class="btn" @click="ban(scope.row)"
                       :state="scope.row.status" v-if="scope.row.status === 1">启用
            </el-button>
            <el-button size="mini" type="text" class="btn" @click="unban(scope.row)"
                       :state="scope.row.status" v-else>禁用
            </el-button>
          </template>
        </el-table-column>
        <el-table-column
            align="center"
            prop="isSelected"
            label="精选"
            sortable="custom"
            width="80">
          <template slot-scope="scope">
            <el-button size="mini" type="text" class="btn" @click="cancelSelect(scope.row)"
                       :state="scope.row.isSelected" v-if="scope.row.isSelected === 1">是
            </el-button>
            <el-button size="mini" type="text" class="btn" @click="updateSelect(scope.row)"
                       :state="scope.row.isSelected" v-else>否
            </el-button>
          </template>
        </el-table-column>
        <el-table-column
            align="center"
            prop="sort"
            label="排序"
            sortable="custom"
            width="80">
        </el-table-column>
        <el-table-column
            align="right"
            fixed="right"
            width="130">
          <template slot-scope="scope">
            <el-button size="mini" type="text" class="btn" @click="toDelete(scope.row)">删除</el-button>
            <el-button size="mini" type="text" class="btn" @click="form=scope.row,drawerVisible=true">详情</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
          v-if="!isScreenSelected"
          :hide-on-single-page="true"
          class="pagination"
          background
          prev-text="Prev"
          next-text="Next"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="page.current"
          :page-size="page.size"
          layout="prev, pager, next"
          :total="page.total">
      </el-pagination>
    </div>

    <!--  弹窗详情 start-->
    <el-drawer title="详情"
               :visible.sync="drawerVisible"
               :show-close="false"
               :wrapperClosable="false"
               class="drawerCommon"
               size="750px">
      <el-form :model="form"
               :rules="rules"
               ref="form"
               class="maxHeight"
               label-width="90px"
               label-suffix="：">
        <el-form-item label="标题" prop="title">
          <el-input v-model="form.title"></el-input>
        </el-form-item>
        <el-form-item label="联系方式" prop="contact">
          <el-input v-model="form.contact"></el-input>
        </el-form-item>
        <el-form-item label="内容" prop="content">
          <el-input type="textarea" v-model="form.content" :autosize="{ minRows: 2, maxRows: 5}"></el-input>
        </el-form-item>
        <el-form-item label="排序" prop="sort">
          <el-input-number v-model="form.sort" :step="1" step-strictly></el-input-number>
        </el-form-item>
        <el-form-item label="图片" prop="headImgPath">
          <el-upload
              class="avatar-uploader"
              :action="iconUploadUrl"
              :show-file-list="false"
              name="uploadFile"
              :on-success="handleIconSuccess">
            <img v-if="form.headImgPath" :src="form.headImgPath" class="avatar">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
      </el-form>
      <div class="footer">
        <el-button size="small" type="primary" @click="submit()">保存</el-button>
        <el-button size="small" @click="drawerVisible=false">取消</el-button>
      </div>
    </el-drawer>
    <!--  弹窗详情 end-->
  </div>
</template>

<script>
import base from '@/api/common';
import Sortable from 'sortablejs';

export default {
  name: "feedbackList",
  data() {
    return {
      feedbackList: [],
      page: {//分页
        current: 1,
        size: 10,
        total: 8,
        orderType: null,
        orderField: null,
      },
      drawerVisible: false,
      form: {},
      iconUploadUrl: base.uploadUrl + 'feedback',
      rules: {
        title: [
          {required: true, message: '请输入标题', trigger: 'blur'},
          {max: 255, message: '长度最长为255', trigger: 'blur'}
        ],
        content: [
          {required: true, message: '请输入反馈内容', trigger: 'blur'},
        ],
        contact: [
          {max: 255, message: '长度最长为255', trigger: 'blur'}
        ],
      },
      isScreenSelected: false,//是否筛选精选
      sortedFeedbackIdList: [],//排序后的idList
    }
  },
  mounted() {
    this.getData();
    this.rowDrop();
  },
  methods: {
    //获得数据
    getData() {
      let that = this;
      if (this.isScreenSelected) {
        this.$ajax.get(base.manager_api.feedback.listSelected).then((res) => {
          if (res.data.status === 'success') {
            that.feedbackList = res.data.list;
          }
        })
      } else {
        this.$ajax.get(base.manager_api.feedback.page, {
          params: {
            page: this.page.current,
            size: this.page.size,
            orderType: this.page.orderType,
            orderField: this.page.orderField,
          }
        }).then((res) => {
          if (res.data.status === 'success') {
            that.feedbackList = res.data.rows;
            that.page.total = res.data.total;
          } else {
            that.$message.error(res.data.message);
          }
        }).catch((err) => {
          console.error(err);
          that.$message.error("获取数据失败");
        })
      }
    },
    // 每页多少条
    handleSizeChange(val) {
      this.page.size = val;
    },
    // 当前页  根据标签页分别执行传输
    handleCurrentChange(val) {
      this.page.current = val;
      this.getData();
    },
    //禁用
    ban(obj) {
      let that = this;
      this.$ajax.get(base.manager_api.feedback.ban.replace("{id}", obj.id)).then((res) => {
        if (res.data.status === 'success') {
          obj.status = 0;
          obj.isSelected = 0;
          that.$message.success("操作成功");
        } else {
          that.$message.error(res.data.message);
        }
      }).catch((err) => {
        console.error(err);
        that.$message.error("操作失败");
      })
    },
    //解封
    unban(obj) {
      let that = this;
      this.$ajax.get(base.manager_api.feedback.unban.replace("{id}", obj.id)).then((res) => {
        if (res.data.status === 'success') {
          obj.status = 1;
          that.$message.success("操作成功");
        } else {
          that.$message.error(res.data.message);
        }
      }).catch((err) => {
        console.error(err);
        that.$message.error("操作失败");
      })
    },
    //删除
    toDelete(obj) {
      let that = this;
      this.$confirm("确认删除吗?", "提示", {
        confirmButtonText: '删除',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$ajax.get(base.manager_api.feedback.delete.replace("{id}", obj.id)).then((res) => {
          if (res.data.status === 'success') {
            that.getData();
            that.$message.success("操作成功");
          } else {
            that.$message.error(res.data.message);
          }
        }).catch((err) => {
          console.error(err);
          that.$message.error("操作失败");
        })
      });
    },
    //提交
    submit() {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          let that = this;
          this.$ajax.post(base.manager_api.feedback.update, this.form).then((res) => {
            if (res.data.status === 'success') {
              that.getData();
              that.drawerVisible = false;
              that.$message.success("操作成功");
            } else {
              that.$message.error(res.data.message);
            }
          }).catch((err) => {
            console.error(err);
            that.$message.error("操作失败");
          })
        } else {
          this.$message.error("请检查数据");
          return false;
        }
      })
    },
    handleIconSuccess(res, file) {
      let that = this;
      if (res.status === 'success') {
        that.form.headImgPath = res.message;
      }
    },
    sortChange(val) {
      this.page.orderField = val.prop;
      if (val.order === "descending") {
        this.page.orderType = 1;
      } else {
        this.page.orderType = 0;
      }
      this.getData();
    },
    //更新精选
    updateSelect(obj) {
      let that = this;
      this.$ajax.get(base.manager_api.feedback.updateSelect.replace("{id}", obj.id)).then((res) => {
        if (res.data.status === 'success') {
          that.$message.success("操作成功");
          that.getData();
        } else {
          that.$message.error(res.data.message);
        }
      }).catch((err) => {
        console.error(err);
        that.$message.error("操作失败");
      })
    },
    //取消精选
    cancelSelect(obj) {
      let that = this;
      this.$ajax.get(base.manager_api.feedback.cancelSelect.replace("{id}", obj.id)).then((res) => {
        if (res.data.status === 'success') {
          obj.isSelected = 0;
          that.$message.success("操作成功");
        } else {
          that.$message.error(res.data.message);
        }
      }).catch((err) => {
        console.error(err);
        that.$message.error("操作失败");
      })
    },
    updateSort() {
      if (this.isScreenSelected) {
        let that = this;
        $(this.feedbackList).each((index, obj) => {
          that.sortedFeedbackIdList[index] = obj.id;
        });
        this.$ajax.post(base.manager_api.feedback.updateSelectedSort, this.sortedFeedbackIdList).then((res) => {
          if (res.data.status === 'success') {
            that.$message.success("排序成功");
            this.getData();
          } else {
            that.$message.error(res.data.message);
          }
        }).catch((err) => {
          console.error(err)
          that.$message.error("操作失败")
        })
      } else {
        this.$message.warning("重新排序需先点击按钮左侧的 '筛选精选'");
      }
    },
    //行拖拽
    rowDrop() {
      const tbody = document.querySelector('.el-table__body-wrapper tbody')
      const _this = this
      Sortable.create(tbody, {
        onEnd({newIndex, oldIndex}) {
          const currRow = _this.feedbackList.splice(oldIndex, 1)[0]
          _this.feedbackList.splice(newIndex, 0, currRow)
        }
      })
    },
  }
}
</script>

<style scoped lang="scss">
@import '../../../assets/css/admin.scss';

button[state='0'] {
  color: #f56c6c
}

button[state='1'] {
  color: #67c23a
}

.catalog_module {
  ::v-deep .el-main {
    height: calc(100vh - 240px);
    min-height: 480px;
  }
}

.aside-ul {
  padding: 0;

  li.aside-li {
    height: 28px;
    line-height: 28px;
    margin: 10px 0;
    padding-left: 40px;
    text-align: left;
    font-size: 14px;
    color: rgb(42, 45, 46);
    cursor: pointer;
  }

  li.aside-li[active='1'] {
    font-weight: 700;
    color: rgb(86, 124, 255);
  }
}

.dict-info {
  padding: 10px 20px;
  position: relative;
  justify-content: space-between;
  align-items: normal;
  font-size: 14px;

  p {
    line-height: 20px;
    margin: 10px 0;

    color: #5e6d82;

    span.title {
      display: inline-block;
      width: 300px;
    }
  }

  ::v-deep label {
    font-size: 16px;
    font-weight: 700;
    color: #1f2f3d;
    margin: 10px 20px 10px 0;
  }

  /* ::v-deep span, p {

   }*/

  /*.dict-operate {
    position: absolute;
    right: 40px;
    top: 20px;

    button {
      padding: 0;
      width: 86px;
      height: 32px;
    }
  }*/
}

button[state='0'] {
  color: #f56c6c
}

button[state='1'] {
  color: #67c23a
}

span.disabled-tips {
  font-size: 12px;
  color: #f56c6c;
  cursor: not-allowed;
}

label.title {
  margin-right: 10px;
  font-weight: 700
}

</style>